import { render, staticRenderFns } from "./sabah-cmp.vue?vue&type=template&id=97e84dee&"
import script from "./sabah-cmp.vue?vue&type=script&lang=js&"
export * from "./sabah-cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports